<template>
  <div class="tw-flex tw-items-center">
    <router-link
      v-if="order.status !== 'DRAFT'"
      :to="{ name: 'order', params: { id: order.id } }"
      class="tw-underline tw-text-secondary-500 hover:tw-text-primary-600 tw-cursor-pointer tw-flex tw-items-center"
    >
      <span class="tw-mr-1">
        {{ order.order_number }}
      </span>
    </router-link>
    <span v-else>-</span>
    <RecurringIcon
      v-if="order?.recurring_instruction"
      class="tw-w-4 tw-h-4 tw-text-primary-600 tw-ml-1 tw-flex-shrink-0"
    />
  </div>
</template>

<script setup lang="ts">
import type { CellContext } from '@tanstack/vue-table';
import { computed } from 'vue';
import RecurringIcon from '@/assets/icons/Loop.svg';

const props = defineProps<{
  info: CellContext<any, any>;
}>();

const order = computed(() => props.info.row.original);
</script>
